// src/components/quotes/ticketPicklists.js
//
// The PURE half of the ticket picklists: shaping and lookup over the lists
// GET /api/tickets/reference returns. No React, no API import — so the
// classification fields and the onboarding modal can import these without
// dragging apiClient (and the MSAL client it constructs at module load) into
// a test. The fetch lives in useTicketPicklists.js.
//
// Shape, confirmed against the live tenant 2026-10-02: picklist values are
// STRINGS, a sub-issue names its parent in `parentValue`, `isActive` is on
// every value.

/* Active values only, in Autotask's own order (sortOrder, then label). */
export const activeSorted = (list) => (Array.isArray(list) ? list : [])
  .filter((v) => v && v.isActive !== false && v.value !== undefined && v.value !== null && v.value !== "")
  .slice()
  .sort((a, b) => (Number(a.sortOrder) || 0) - (Number(b.sortOrder) || 0) || String(a.label || "").localeCompare(String(b.label || "")));

/* "" (nothing chosen) → null; otherwise the picklist id as a number. */
export const idOrNull = (v) => (v === "" || v === null || v === undefined ? null : Number(v));

/* The chosen parent's children, and nothing else. */
export const subIssuesFor = (picklists, issueType) => (picklists && issueType !== "" && issueType != null
  ? picklists.subIssueTypes.filter((v) => String(v.parentValue) === String(issueType))
  : []);
